import CollectionDashboardResponseBase from './base/CollectionDashboardResponseBase';

/**
 * @class CollectionDashboardResponse
 * @extends CollectionDashboardResponseBase
 */
class CollectionDashboardResponse extends CollectionDashboardResponseBase {
	get totalCollected() {
		return this.totalAmountBvDrops + this.totalAmountVgtDrops + this.totalAmountRtAudits
	}
}

export default CollectionDashboardResponse;
